const AboutUsList = {
	group: '关于我们',
	list: [
		{
			id: 101,
			title: '量大信息研究院（平台运营）',
			goto: { path: '/info', query: { group: '关于我们', id: 101, type: 'content', title: '量大信息研究院（平台运营）' } },
			class: 'is-open',
			content:
				'<p>\n' +
				'\t\t\t\t\t\t量大（北京）信息科技研究院有限公司，作为特种设备行业的先锋力量，凭借深厚的专业底蕴与创新精神，致力于推动行业标准的数字化与智能化发展，为特种设备相关单位与个人提供高效、精准的解决方案，助力行业迈向高效、安全、智能的新时代。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h5>一、公司概况</h5>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t北京品读文化发展有限公司，作为全国锅炉压力容器标准化技术委员会（SAC/TC262）法规标准图书指定服务窗口，深耕特种设备领域十余载，凭借深厚的行业积淀与扎实的专业能力，已发展为特种设备合规服务领域的骨干力量。公司依托全国锅炉压力容器标准化技术委员会在锅炉、压力容器等专业领域的标准制定核心优势，以正版法规和标准为核心支撑，并针对特种设备行业高风险、高专业的行业特性，公司精准打造一站式合规解决方案，匹配行业全产业链的合规需求。服务网络广泛覆盖行业各关键环节，为各类用户提供专业、高效的合规支撑，助力行业安全稳健发展。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t量大（北京）信息科技研究院有限公司，前身为北京品读文化发展有限公司。在行业发展的浪潮中，我们敏锐捕捉到互联网时代对标准图书使用场景的变革，主动开启战略转型与创新实践，从传统的纸版标准供应、承接标准编写与出版服务，到如今专注于标准的数字化与智能化应用开发，一路砥砺前行，始终坚持以创新引领行业发展，以专业服务客户需求。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h5>二、公司文化与价值观</h5>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t我们专注于特种设备行业标准的数字化、智能化服务。我们相信，标准不应是应付检查的僵硬教条，而应是赋能创新的活水源泉。让我们赋予它生命，使其成为您手中的魔法棒：只需轻松一挥，标准中的要求与数据便能精准注入，自动完成从设计到生产的全部衔接，将效率真正变为魔法。因此，我们致力于打造一个简单便捷的平台，让每一位使用标准的人都能轻松地在标准中找到他们想要的内容，从而提高工作效率，推动行业的可持续发展。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h5>三、合作单位</h5>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t在发展过程中，我们与中国计量大学建立了紧密的合作关系。借助高校的科研力量与学术资源，我们不断提升自身的技术水平与创新能力，共同开展前沿技术研究与应用开发，为特种设备行业的标准化、数字化、智能化发展注入新的活力。通过与高校的深度合作，我们不仅能够及时掌握行业最新研究成果，还能为专业人才提供实践平台，促进产学研的深度融合，推动行业的可持续发展。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h5>四、公司业务范围</h5>\n' +
				'\t\t\t\t\t<p>目前，我们倾力打造的产品 —— 特规通特种设备标准规范智能服务平台，已成为行业内的标杆之作。该平台凭借其强大的功能，为用户提供全方位、一站式的服务体验。</p>\n' +
				'\t\t\t\t\t<h6>AI 行业大模型</h6>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t特规通搭载的 AI 行业大模型，以权威法规标准为依据，杜绝 “幻觉” 问题。支持自然语言对话，能输出文本、图表、公式等多模态答案，来源可溯源、结果精准专业。搭配 Agent\n' +
				'\t\t\t\t\t\t智能工作流与持续优化机制，为特种设备行业的专业人士提供精准、可靠的信息支持。无论是法规解读、标准应用，还是技术难题的攻克，AI\n' +
				'\t\t\t\t\t\t大模型都能迅速给出科学合理的建议，帮助用户在复杂多变的行业环境中做出明智决策，提升工作效率与质量。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h6>法规标准库</h6>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t特规通的法规标准库堪称行业宝典，汇聚 3000 份特种设备全类型权威文件，覆盖八大类设备全生命周期规定，涵盖法律、TSG 规范、国家标准等多类型文献，搭配 20 万\n' +
				'\t\t\t\t\t\t册行业及周边领域拓展资源，是行业最全的合规知识库。支持多途径检索、AI\n' +
				'\t\t\t\t\t\t自然语言查询、智能模糊匹配等多维搜索功能，详细题录信息助你快速锁定所需，更有智能阅读模式提供目录导航、交叉引用、笔记标注等便捷体验。平台同步提供正版采购渠道，涵盖纸质书、原版电子\n' +
				'\t\t\t\t\t\tPDF、特规通独有的智能阅读版三种形式，全部授权可开发票，注册用户享会员折扣。购买后支持终身云存储，文件状态实时更新提醒，让专业知识获取高效、合规、无后顾之忧。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h6>行业数据库</h6>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t基于对特种设备行业的深刻理解和长期积累，我们精心整理了行业内使用率高的内容，提炼法规标准核心数据，打造术语、符号、材料、法兰等特色数据库，整合官方问答、国家标准信息等资源。跨领域一站式查询，碎片化数据系统呈现，满足工程计算、选材比对、政策解读等专业需求，未来更将持续扩充行业专属数据库。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<h6>个人书架</h6>\n' +
				'\t\t\t\t\t<p>支持标准收藏、书夹分类与智能推荐，实时推送文件更新提醒。联动 AI 问答、有效性查询等功能，整合阅读笔记与在线文档创作工具，打造 “收藏 - 管理 - 学习 - 输出” 的知识管理闭环，助力专业成长。</p>\n' +
				'\t\t\t\t\t<h6>社区</h6>\n' +
				'\t\t\t\t\t<p>聚焦特种设备领域，提供行业新闻动态、法规标准研讨、资源供需发布等核心服务。搭建标准制定反馈、技术难题交流、人才项目对接的线上平台，打破地域单位壁垒，促进信息共享与合作共赢。</p>\n' +
				'\t\t\t\t\t<h5>五、面向客户与合作伙伴</h5>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t量大（北京）信息科技研究院有限公司始终以客户为中心，以市场需求为导向，致力于为特种设备相关单位与个人，提供全方位、高质量的服务。我们深知，每一位客户都是我们成长的基石，每一个项目都是我们创新的契机。因此，我们不断优化产品功能，提升服务质量，力求为客户提供超出预期的体验。\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<p>\n' +
				'\t\t\t\t\t\t我们热忱欢迎广大客户与合作伙伴与我们携手共进，共同探索特种设备行业的数字化、智能化发展之路。无论您是寻求高效、便捷的标准查询工具，还是希望借助我们的技术力量提升自身的数字化水平，我们都将以开放的心态、专业的服务，与您开展全方位、多层次的合作。让我们共同努力，为特种设备行业的安全、高效、可持续发展贡献力量，共创美好未来！\n' +
				'\t\t\t\t\t</p>\n' +
				'\t\t\t\t\t<p>量大（北京）信息科技研究院有限公司，以专业铸就品质，以创新引领未来。我们期待与您相约在特种设备行业的数字化浪潮中，共同书写行业发展的新篇章！</p>'
		},
		{
			id: 103,
			title: '品读文化（图书销售）',
			goto: { path: '/info', query: { group: '关于我们', id: 103, type: 'content', title: '品读文化（图书销售）' } },
			class: '',
			content:
				'品读文化（图书销售）-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		{
			id: 1,
			title: '用户协议',
			goto: { path: '/info', query: { group: '关于我们', id: 1, type: 'content', title: '用户协议' } },
			class: '',
			content:
				'注册协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		{
			id: 2,
			title: '隐私协议',
			goto: { path: '/info', query: { group: '关于我们', id: 2, type: 'content', title: '隐私协议' } },
			class: '',
			content:
				'隐私协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		{
			id: 3,
			title: '图书销售协议',
			goto: { path: '/info', query: { group: '关于我们', id: 3, type: 'content', title: '图书销售协议' } },
			class: '',
			content:
				'图书销售协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		// {
		// 	id: 1001,
		// 	title: '操作说明',
		// 	goto: { path: '/guide'},
		// 	class: ''
		// }
		// {
		// 	id: 102,
		// 	title: '在线问题反馈',
		// 	goto: { path: '/info', query: { group: '关于我们', id: 102, type: 'feedBack', title: '在线问题反馈' } },
		// 	class: '',
		// 	content:
		// 		'在线问题反馈-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		// }
	]
};

export default AboutUsList;
